import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import { withRights } from 'providers/RightsConsumer';
import { Grid } from '@mui/material';
import BlockIcon from '@mui/icons-material/Block';
import OfferPartnerIncomeDataItemComponent from './OfferPartnerIncomeDataItemComponent';
import { Button } from '@totalsoft/rocket-ui';

class OfferPartnerIncomeDataListComponent extends React.PureComponent {
  editableItem = () => {
    if (!this.props.fromExternalSource) {
      return true;
    } else if (this.props.rights.externalIncomesWrite) {
      return true;
    } else if (this.props.rights.anafPfaIncomeWrite) {
      return true;
    } else {
      return false;
    }
  };

  visibleData = () => {
    if (this.props.sensitiveInfo && !this.props.rights.clientSensitiveInfoRead) {
      return false;
    } else {
      return true;
    }
  };

  render() {
    const { t, data, loadDetailOptions, editable, onEdit, onSave, saving, onCancel, onChange, onPeriodChange, rights, cardIndex } =
      this.props;

    return (
      <>
        {this.visibleData() ? (
          <Grid container spacing={1}>
            <Grid item xs={4} sm={4} md={4}></Grid>
            <Grid item xs={4} sm={4} md={4}>
              {t('OfferEdit.Client.IncomeData.Period')}
            </Grid>
            <Grid item xs={4} sm={4} md={4}>
              {t('OfferEdit.Client.IncomeData.Value')}
            </Grid>
            {data.map((a, index) => {
              return (
                <OfferPartnerIncomeDataItemComponent
                  cardIndex={cardIndex}
                  key={index}
                  idx={index}
                  data={a}
                  loadDetailOptions={loadDetailOptions}
                  editable={editable}
                  onChange={onChange}
                  onPeriodChange={onPeriodChange}
                />
              );
            })}
            {this.editableItem() && !rights.isImage ? (
              editable ? (
                data.length > 0 && (
                  <Grid container mt={2} gap={1}>
                    <Button
                      id={'offerPartnerIncomeDataCard_' + cardIndex + '_saveBtn'}
                      color='primary'
                      variant='contained'
                      onClick={onSave}
                      disabled={saving || rights.readOnlyFull || !rights.clientIncomeSourcesWrite || !rights.anafPfaIncomeWrite}
                    >
                      {saving ? t('Saving') : t('Save')}
                    </Button>
                    <Button
                      id={'offerPartnerIncomeDataCard_' + cardIndex + '_cancelBtn'}
                      color='primary'
                      variant='outlined'
                      onClick={onCancel}
                      disabled={saving || rights.readOnlyFull || !rights.clientIncomeSourcesWrite || !rights.anafPfaIncomeWrite}
                    >
                      {t('Cancel')}
                    </Button>
                  </Grid>
                )
              ) : (
                data.length > 0 && (
                  <Button
                    id={'offerPartnerIncomeDataCard_' + cardIndex + '_changeBtn'}
                    sx={{ mt: 2 }}
                    color='primary'
                    variant='contained'
                    onClick={onEdit}
                    disabled={saving || rights.readOnlyFull || !rights.clientIncomeSourcesWrite || !rights.anafPfaIncomeWrite}
                  >
                    {t('Change')}
                  </Button>
                )
              )
            ) : (
              <div></div>
            )}
          </Grid>
        ) : (
          <Grid container spacing={1}>
            <Grid item xs={12} sm={12} md={12}></Grid>
            <Grid item xs={4} sm={4} md={4}></Grid>
            <Grid item xs={1} sm={1} md={1}>
              <BlockIcon />
            </Grid>
            <Grid item xs={3} sm={3} md={3}>
              {t('OfferEdit.Client.IncomeData.SensitiveInfo')}
            </Grid>
          </Grid>
        )}
      </>
    );
  }
}

OfferPartnerIncomeDataListComponent.propTypes = {
  t: PropTypes.func.isRequired,
  data: PropTypes.array.isRequired,
  loadDetailOptions: PropTypes.func,
  editable: PropTypes.bool.isRequired,
  onEdit: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  saving: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  onCancel: PropTypes.func,
  onPeriodChange: PropTypes.func.isRequired,
  rights: PropTypes.object.isRequired,
  fromExternalSource: PropTypes.bool.isRequired,
  sensitiveInfo: PropTypes.bool,
  cardIndex: PropTypes.number
};

export default compose(withTranslation())(withRights(OfferPartnerIncomeDataListComponent));
